import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MakeOfferDialogComponent } from '../make-offer-dialog/make-offer-dialog.component';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

@Component({
    selector: 'app-make-offer-btn',
        standalone: true,
imports: [
        TranslatePipe
    ],
    templateUrl: './make-offer-btn.component.html',
    styleUrl: './make-offer-btn.component.scss'
})
export class MakeOfferBtnComponent {
  @Input() dir: any;
  @Input() horseId: any;
  @Input() currencyLocal: any;
  @Input() isDisabled: boolean = false;
  constructor(private dialog: MatDialog, public localeService: LocaleService) {}

  openMakeAnOffer(event: any) {
    event.stopPropagation();
    this.dialog.open(MakeOfferDialogComponent, {
      direction: this.localeService.dir,
      width: '400px',
      panelClass: ['buyer-theme'],

      data: {

        auction_item_id: this.horseId,
        currencyLocal: this.currencyLocal,
      },
    });
  }
}
